
export default function WhyChooseUsSection() {
  const advantages = [
    {
      icon: 'ri-award-line',
      title: 'Expertise Sécurité Belgique',
      description: 'Spécialistes en sécurité électronique avec une connaissance approfondie du marché belge et des réglementations locales.',
      color: 'text-orange-500'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Service Local Charleroi',
      description: 'Basés à Charleroi, nous intervenons rapidement dans toute la Belgique : Bruxelles, Namur, Liège, Mons et environs.',
      color: 'text-blue-500'
    },
    {
      icon: 'ri-tools-line',
      title: 'Installation Professionnelle',
      description: 'Installation d\'alarme maison, caméra de surveillance et contrôle d\'accès par des techniciens certifiés en Belgique.',
      color: 'text-green-500'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Support Technique 24/7',
      description: 'Maintenance et support technique disponible 24h/24 pour tous vos systèmes de sécurité en Belgique.',
      color: 'text-purple-500'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Garantie Qualité',
      description: 'Tous nos équipements de sécurité sont garantis et conformes aux normes européennes et belges.',
      color: 'text-red-500'
    },
    {
      icon: 'ri-money-euro-circle-line',
      title: 'Devis Gratuit Belgique',
      description: 'Évaluation gratuite de vos besoins en sécurité et devis personnalisé pour particuliers et PME en Belgique.',
      color: 'text-indigo-500'
    }
  ];

  return (
    <section id="pourquoi-nous" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Pourquoi Choisir FMS Protec en Belgique ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            <strong>Entreprise sécurité Belgique</strong> de confiance basée à <strong>Charleroi</strong>, nous sommes votre partenaire de référence pour tous vos projets de sécurité électronique
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-1 text-center"
            >
              <div className={`w-16 h-16 ${advantage.color.replace('text-', 'bg-')}/10 rounded-xl flex items-center justify-center mx-auto mb-6`}>
                <i className={`${advantage.icon} text-3xl ${advantage.color}`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                {advantage.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>

        {/* Section témoignages clients */}
        <div className="mt-16 bg-white rounded-xl p-8 shadow-lg">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
            Nos Clients en Belgique Nous Font Confiance
          </h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-orange-500 mb-2">500+</div>
              <p className="text-gray-600">Installations réalisées en Belgique</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-500 mb-2">24/7</div>
              <p className="text-gray-600">Support technique disponible</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-green-500 mb-2">100%</div>
              <p className="text-gray-600">Clients satisfaits de nos services</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
            className="bg-gradient-to-r from-orange-500 to-blue-500 hover:from-orange-600 hover:to-blue-600 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg hover:shadow-xl"
          >
            <i className="ri-phone-line mr-2"></i>
            Contactez votre expert sécurité Belgique
          </button>
        </div>
      </div>
    </section>
  );
}